<template>
  <button
    :type="buttonType"
    :class="[
      'd-inline-flex',
      'btn',
      `btn-${theme}`,
      {
        'btn-sm': size === 'sm',
        'btn-lg': size === 'lg',
        'btn-icon-only': isIconOnly,
        'btn-with-icon': isIconLeft || isIconCenter || isIconRight,
        'is-loading': isLoading,
      }
    ]"
    :disabled="disabled"
    v-on="$listeners"
  >
    <template v-if="isIconOnly">
      <m-icon :variant="iconVariant" />
    </template>
    <template v-else>
      <m-icon
        v-if="isIconLeft"
        class="ml-n2 is-left align-self-center"
        :variant="iconVariant"
      />
      <m-icon
        v-if="isIconCenter"
        :variant="iconVariant"
      />
      <slot>
        <span :class="[
          'align-self-center',
          {
            'mr-n1': isIconLeft,
            'ml-n1': isIconRight,
          }
        ]">{{ convertedLabel }}</span>
      </slot>
      <m-icon
        v-if="isIconRight"
        class="mr-n2 is-right align-self-center"
        :variant="iconVariant"
      />
    </template>
  </button>
</template>

<script>
import MIcon from '../Icon';
import { upperFirst } from 'lodash/string';

export default {
  name: 'MButton',
  components: { MIcon },
  props: {
    variant: {
      type: String,
      default: 'default',
    },
    theme: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    iconVariant: {
      type: String,
      default: '',
    },
    buttonType: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    convertedLabel() {
      return upperFirst(this.label);
    },
    isIconOnly() {
      return this.variant === 'icon-only';
    },
    isIconLeft() {
      return this.variant === 'icon-left';
    },
    isIconRight() {
      return this.variant === 'icon-right';
    },
    isIconCenter() {
      return this.variant === 'icon-center';
    },
    isLoading () {
      return this.variant === 'loading';
    },
  },
};
</script>
